import clsx from 'clsx'
import React from 'react'
import {FC} from 'react'
import {Row} from 'react-table'
import {PropertyRegistries} from '../../core/_models'
import {KTSVG} from '../../../../../../../../../../../_metronic/helpers'

type Props = {
  row: Row<PropertyRegistries>
}

const CustomRow: FC<Props> = ({row}) => {
  const [visible, setVisible] = React.useState(false)
  let linha = row.original.character

  function handleVisible() {
    if (visible === false) {
      setVisible(true)
    } else {
      setVisible(false)
    }
  }

  return (
    <>
      <tr {...row.getRowProps()}>
        {row.cells.map((cell) => {
          return (
            <td
              {...cell.getCellProps()}
              className={clsx({'text-center min-w-100px': cell.column.id === 'actions'})}
            >
              {/* inicio da tabela do plano de ação */}
              {linha === 'imposing' && cell.column.id === 'actions' && (
                <button
                  onClick={() => handleVisible()}
                  title='Plano de Ação'
                  className='btn btn-icon btn-outline btn-light btn-active-color-primary  btn-outline btn-sm me-2'
                >
                  <KTSVG path='/media/icons/duotune/general/gen019.svg' className='svg-icon-3' />
                </button>
              )}

              {cell.render('Cell')}
            </td>
          )
        })}
      </tr>

      {/* inicio da tabela do plano de ação */}
    </>
  )
}

export {CustomRow}
